import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { ValidatedSelectOptionModel } from '../../../validations/validated-dropdown.component'
import { PortalGlobals } from '../../../portalglobals'
import { RelationshipToEnrollee } from '../../models/relationshipToEnrollee'

@Component({
    selector: 'indvrep',
    templateUrl: 'indvrep.component.html',
    styleUrls: ['indvrep.component.scss']
})
export class IndvRepComponent implements OnInit {
    notBlankValidator = new NotBlankGenericFieldValidator()
    @Input() isSpanish: boolean
    @Input() isDisabled: boolean
    @Input() isBlueText: boolean
    @Input() AgentOrgID: Number
    @Input() isAppIndTitle: boolean
    @Input() enrollmentindvrepViewModel: EnrollmentViewModel
    @Output() appIndClick = new EventEmitter<boolean>()

    public rblReltoEnroll: ValidatedSelectOptionModel[] = []
    visibleFrom2025: boolean
    isAppInd: boolean
    public rblAppIndIND: ValidatedRadioButtonModel[] = []
    public relationshipToEnrolleeList: RelationshipToEnrollee[] = [] as RelationshipToEnrollee[]

    constructor(private _enrollmentGateway: EnrollmentGateway, public _global: PortalGlobals) {}

    ngOnInit() {
        this.loadData()
    }

    loadData() {
        this.visibleFrom2025 = this._global.selectedPlanYear > this._global.Planyear2024
        this.isAppInd = !!(this.enrollmentindvrepViewModel.INDREPIND && this.enrollmentindvrepViewModel.INDREPIND == 'Yes')

        this.rblAppIndIND.push(
            {
                value: 'No',
                htmlLabel: 'No',
                disabled: this.isDisabled
            },
            {
                value: 'Yes',
                htmlLabel: this.isSpanish ? 'Si' : 'Yes',
                disabled: this.isDisabled
            }
        )

        this._enrollmentGateway.getRelationshipToEnrolleeData().subscribe((model: RelationshipToEnrollee[]) => {
            this.relationshipToEnrolleeList = model

            this.relationshipToEnrolleeList.forEach((element, index) => {
                this.rblReltoEnroll.push({ value: element.RelationshipToEnrolleeCode, text: element.RelationshipToEnrolleeValue })
            })
            this.relToEnrollonValueChange(this.enrollmentindvrepViewModel.RELTOENROLL)
        })
    }

    selectedNo(enrollObject: EnrollmentViewModel) {
        if (enrollObject == null) {
            this.enrollmentindvrepViewModel.RELTOENROLL = ''
            this.enrollmentindvrepViewModel.displayRELTOENROLL = ''
            this.enrollmentindvrepViewModel.NPN = ''
            this.enrollmentindvrepViewModel.INDREPNAME = ''
        } else {
            enrollObject.RELTOENROLL = ''
            enrollObject.displayRELTOENROLL = ''
            enrollObject.NPN = ''
            enrollObject.INDREPNAME = ''
        }
    }

    rblAppIndINDClick(event: any): void {
        if (event === 'Yes') {
            this.isAppInd = true
        } else {
            this.isAppInd = false
            this.selectedNo(this.enrollmentindvrepViewModel)
        }
        this.enrollmentindvrepViewModel.INDREPIND = event
        this.appIndClick.emit(this.isAppInd)
    }
    isNPNmandatory: boolean = false
    relToEnrollonValueChange(value: any): void {
        this.enrollmentindvrepViewModel.RELTOENROLL = value
        this.relationshipToEnrolleeList.forEach((element, index) => {
            if (element.RelationshipToEnrolleeCode == Number(value)) {
                this.enrollmentindvrepViewModel.displayRELTOENROLL = element.RelationshipToEnrolleeValue
            }
        })

        if (this.enrollmentindvrepViewModel.displayRELTOENROLL == 'Agent' || this.enrollmentindvrepViewModel.displayRELTOENROLL == 'Broker') {
            this.isNPNmandatory = true
        } else {
            this.isNPNmandatory = false
        }
    }
}
